import React, { useEffect, useState } from 'react';
import { TextField, Select, MenuItem, FormControl, InputLabel, FormControlLabel, Checkbox, Grid, Button } from '@mui/material';
import apiInstance from '../../../services/ServiceApi';
import { COMPONENTES_DISPONIBLES } from '../../../utilities/constant';

function FormularioRellenoBO({ campos, valoresIniciales, venta ,identificador,cuenta_cliente,id_linea_negocio}) {

    const [valores, setValores] = useState({});
    useEffect(() => {
        setValores(campos.reduce((obj, campo) => {
            let valorInicial = valoresIniciales ? valoresIniciales[campo.label] : undefined;
            const valoresPorTipo = {
                texto: '',
                correo: '',
                input: '',
                select: '', // Asumiendo que el valor inicial para un select es una cadena vacía
                checkbox: false,
                numero: '',
                decimal: '',
                fecha: null,
                date: null, // Asumiendo que el valor inicial para una fecha es null
            };
            valorInicial = valorInicial !== undefined ? valorInicial : (valoresPorTipo[campo.tipo] || '');

            obj[campo.label] = valorInicial;

            return obj;

        }, {}));
    }, [campos, valoresIniciales]);


    const handleChange = (e, campo) => {
        setValores(prevValores => ({
            ...prevValores,
            [campo.label]: e.target.type === "checkbox" ? e.target.checked : e.target.value
        }));
    };

    const handleSubmit = () => {
        if (!esFormularioValido()) {
            alert('Por favor, rellena todos los campos requeridos');
            return;
        }
        const datos = {
            datos: valores,
            estado_validacion: 4
        };
        apiInstance.put(`venta/${venta}/`, datos)
            .then(res => {
                console.log(res);
                //getMisVentas();
            })
            .catch(err => {
                console.log(err);
            });
    };

    const esFormularioValido = () => {
        for (let campo of campos) {
            if (campo.requerido && (valores[campo.label] === undefined || valores[campo.label] === '')) {
                alert(`Por favor, rellena el campo requerido: ${campo.label}`);
                return false;
            }
            if (!campo.requerido && Object.keys(campo.dependencias || {}).length > 0) {
                const dependenciaCumplida = Object.entries(campo.dependencias).some(([key, value]) => valores[key] === value);
                if (dependenciaCumplida && (valores[campo.label] === undefined || valores[campo.label] === '')) {
                    alert(`Por favor, rellena el campo requerido por dependencia: ${campo.label}`);
                    return false;
                }
            }
        }
        return true;
    }

    return (
        <Grid container spacing={2}>
            {campos.map((campo, index) => {
                if (campo.tipo === 'dependencia') {
                    const ComponenteSeleccionado = COMPONENTES_DISPONIBLES[campo.nombreComponente];
                    return ComponenteSeleccionado ? (
                        <Grid item xs={12} md={campo.columnas} key={index}>
                            <ComponenteSeleccionado
                                        identificador = {identificador} 
                                        id_linea_negocio={id_linea_negocio} 
                                        cuenta_cliente={cuenta_cliente}
                                        etiqueta = {campo.label}
                                        user_bo={true}
                                        valoresIniciales={valoresIniciales[campo.label]}
                                        onChange={(data) => setValores({...valores, [campo.label]: data})}
                                    />
                        </Grid>
                    ) : null;
                } else {
                    return (
                        <Grid item xs={12} md={campo.columnas} key={index}>
                            {campo.tipo === 'texto' &&
                                <TextField
                                    label={campo.label}
                                    variant="outlined"
                                    value={valores[campo.label] || ''}
                                    onChange={(e) => handleChange(e, campo)}
                                    required={campo.requerido}
                                    fullWidth
                                />
                            }
                            {campo.tipo === 'select' &&
                                <FormControl variant="outlined" required={campo.requerido} fullWidth>
                                    <InputLabel>{campo.label}</InputLabel>
                                    <Select
                                        value={valores[campo.label] || ''}
                                        onChange={(e) => handleChange(e, campo)}
                                    >
                                        {campo.opciones.map((opcion, indexOpcion) => <MenuItem value={opcion} key={indexOpcion}>{opcion}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            }
                            {campo.tipo === 'checkbox' &&
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={valores[campo.label] || false}
                                            onChange={(e) => handleChange(campo, e.target.checked)}
                                        />
                                    }
                                    label={campo.label}
                                />
                            }
                            {campo.tipo === 'numero' &&
                                <TextField
                                    label={campo.label}
                                    variant="outlined"
                                    value={valores[campo.label]}
                                    onChange={(e) => handleChange(e, campo)}
                                    required={campo.requerido}
                                    fullWidth
                                    type="number"
                                    inputProps={{
                                        maxLength: campo.digitosLimite
                                    }}
                                />
                            }
                            {campo.tipo === 'correo' &&
                                <TextField
                                    label={campo.label}
                                    variant="outlined"
                                    value={valores[campo.label]}
                                    onChange={(e) => handleChange(e, campo)}
                                    required={campo.requerido}
                                    fullWidth
                                    type="email"
                                />
                            }
                            {campo.tipo === 'date' &&
                                <TextField
                                    label={campo.label}
                                    variant="outlined"
                                    value={valores[campo.label]}
                                    onChange={(e) => handleChange(e, campo)}
                                    required={campo.requerido}
                                    fullWidth
                                    type="date"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            }
                            {campo.tipo === 'decimal' &&
                                <TextField
                                    label={campo.label}
                                    variant="outlined"
                                    value={valores[campo.label]}
                                    onChange={(e) => handleChange(e, campo)}
                                    required={campo.requerido}
                                    fullWidth
                                    type="number"
                                    inputProps={{
                                        step: "0.01"
                                    }}
                                />
                            }
                        </Grid>
                    );
                }
            })}
            <Button variant="contained" color="primary" onClick={handleSubmit}>Guardar</Button>
        </Grid>
    );
    
}

export default FormularioRellenoBO;
